const sectionCardVitalSliderCss = `
[data-type='section-card-vital-slider'] * {
  box-sizing: border-box;
}

[data-type='section-card-vital-slider'] [data-attribute='card-container'] {
  color: var(--color-text, #000000);
}

[data-type='section-card-vital-slider'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-vital-slider'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-vital-slider'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-vital-slider'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-card-vital-slider'] .wrap-card .title-card {
  width: 100%;
  margin-bottom: 24px;
}

[data-type='section-card-vital-slider'] .wrap-card .title-card[data-show-title='false'] {
  display: none !important;
}

[data-type='section-card-vital-slider'] .wrap-card h1,
[data-type='section-card-vital-slider'] .wrap-card h2,
[data-type='section-card-vital-slider'] .wrap-card h3 {
  font-size: 24px;
  line-height: 1.4;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-vital-slider'] p {
  font-size: 16px;
  margin: 0 !important;
  line-height: 1.4;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content {
  position: relative;
  width: 100%;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper {
  width: 100%;
  margin: 0 auto;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper .swiper-slide {
  height: auto;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next,
[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev {
  z-index: 2;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  margin-top: 0;
  background: #000000a1;
  border-radius: 50%;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next::after,
[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev::after {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next.swiper-button-disabled,
[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev.swiper-button-disabled {
  opacity: 0.35;
  cursor: default;
  pointer-events: none;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next.swiper-button-lock,
[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev.swiper-button-lock {
  display: none;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev {
  left: 0;
}

[data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next {
  right: 0;
}

[data-type='section-card-vital-slider'] .wrap-item {
  background: var(--item-background, #ffffff);
  border-radius: 30px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 28px;
}

[data-type='section-card-vital-slider'] .wrap-img img {
  width: 100%;
  height: auto;
  display: block;
}

[data-type='section-card-vital-slider'] .description-item {
  flex: 1;
  background: var(--item-des-background, #daecf0);
  border-radius: 20px;
}

[data-type='section-card-vital-slider'] .description-item[data-padding='true'] {
  padding: 16px 28px;
}

[data-type='section-card-vital-slider'] .description-item[data-padding='false'] {
  padding: 0;
}

[data-type='section-card-vital-slider'] .description-item h1,
[data-type='section-card-vital-slider'] .description-item h2,
[data-type='section-card-vital-slider'] .description-item h3 {
  font-size: 18px;
  line-height: 1.4;
  margin: 0 0 8px 0 !important;
}

[data-type='section-card-vital-slider'] .description-item p {
  font-size: 18px;
  margin: 0 !important;
  line-height: 1.4;
}

@container (max-width: 768px) {
  [data-type='section-card-vital-slider'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-vital-slider'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-vital-slider'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-card-vital-slider'] .wrap-card .title-card {
    margin-bottom: 16px;
  }

  [data-type='section-card-vital-slider'] .wrap-card h1,
  [data-type='section-card-vital-slider'] .wrap-card h2,
  [data-type='section-card-vital-slider'] .wrap-card h3 {
    font-size: 20px;
    margin: 0 0 8px 0 !important;
  }

  [data-type='section-card-vital-slider'] p {
    font-size: 14px;
  }

  [data-type='section-card-vital-slider'] .wrap-item {
    gap: 16px;
    padding: 16px;
  }

  [data-type='section-card-vital-slider'] .description-item[data-padding='true'] {
    padding: 16px;
  }

  [data-type='section-card-vital-slider'] .description-item h1,
  [data-type='section-card-vital-slider'] .description-item h2,
  [data-type='section-card-vital-slider'] .description-item h3 {
    font-size: 16px;
  }

  [data-type='section-card-vital-slider'] .description-item p {
    font-size: 16px;
  }
}

@container (max-width: 640px) {
  [data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper {
    padding: 0;
  }

  [data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-next,
  [data-type='section-card-vital-slider'] .wrap-card > .wrap-content .swiper-button-prev {
    display: none;
  }
}
`;
export default sectionCardVitalSliderCss;
